import { ControlCommunicationService } from '@app/form-builder/services/control-communication.service'
import { FormGroup, FormControl } from '@angular/forms'
import { FormBuilderComponent } from '@app/form-builder/form-builder.component'
import { UnknownParams, ControlElement } from '@app/form-builder/interfaces/form.interface'
import { Component, OnInit, Input, Pipe } from '@angular/core'
import { DecimalPipe } from '@angular/common'
import { ActivatedRoute } from '@angular/router'

import * as moment from 'moment-timezone'
moment.tz.setDefault('America/Mexico_City')
moment.locale('es-mx')

@Pipe({
    name: 'numberFormatt'
})
export class NumericPipe {
    transformFloat(val: any, ...args: any[]) {
        //console.log("pipe", val, args)
        const format = args[0] ? '1.4-4' : '1.4-4'; 
        return this.decimalPipe.transform(val, format, 'en-US');
    }

    transformInt(val: any, ...args: any[]) {
        //console.log("pipe", val, args)
        const format = args[0] ? '1.0-0' : '1.0-0'; 
        return this.decimalPipe.transform(val, format, 'en-US');
    }

    constructor(private decimalPipe: DecimalPipe) { }
}

@Component({
    selector: 'input-element',
    templateUrl: './input.component.html',
    providers: [NumericPipe]
})
export class InputComponent implements OnInit {
    minDate: String = moment().format("YYYY-MM-DD")
    maxDate: String = moment().format("YYYY-MM-DD")

    minYear: String = moment().startOf('year').format('YYYY-MM-DD')

    attributes: UnknownParams = {}
    validations: UnknownParams = {}

    @Input() form: FormGroup

    @Input() data: ControlElement
    
    // inject parent FormBuilder Component in order to access FormGroup
    constructor(
        private parentControl: FormBuilderComponent, 
        private pipe: NumericPipe, 
        private route: ActivatedRoute,
        private communicationService: ControlCommunicationService,
    ) {
        this.communicationService.changeEmmited$.subscribe(msg => {
			if (msg.identifier === 'submit') {
                if(!this.attributes.coordinate) {
                    if (this.attributes.type === 'number') {
                        var val: string = this.form.get(this.attributes.name).value
                        val = val !== null ? "" + val : ''

                        const valueTemp = val.includes(',') ? val.split(",").join("") : val
                        const numberValue = isNaN(parseFloat(valueTemp)) ? 0 : parseFloat(valueTemp)

                        this.form.get(this.attributes.name).patchValue(numberValue)
                    } else if(this.attributes.type === 'number_integer') {
                        var val: string = this.form.get(this.attributes.name).value
                        val = val !== null ? "" + val : ''

                        const valueTemp = val.includes(',') ? val.split(",").join("") : val
                        const numberValue = isNaN(parseInt(valueTemp)) ? 0 : parseInt(valueTemp)

                        this.form.get(this.attributes.name).patchValue(numberValue)
                    }
                } else if(this.attributes.coordinate) {
                    var val: string = this.form.get(this.attributes.name).value
                    val = val !== null ? val : '0'
                    val = isNaN(parseInt(val)) ? '0' : val

                    //console.log(val, typeof val)

                    this.form.get(this.attributes.name).patchValue(val)
                }
			} else if(msg.identifier === 'date-ranges') {
                this.minDate = moment(msg.form['desde']).format("YYYY-MM-DD")
                this.maxDate = moment(msg.form['hasta']).format("YYYY-MM-DD")
            } else if(msg.identifier === 'addressUnitAccDoc') {
                if(this.attributes.name === 'direccion_unidad_produccion') {
                    const unit = msg.unit
                    const unitsWithProducts = JSON.parse(localStorage.getItem('unitsAccDoc'))

                    if(!!unitsWithProducts) {
                        const unitData = unitsWithProducts[unit] || []
                        const address = unitData?.address || ''
                        this.form.get(this.attributes.name).patchValue(address)
                    }
                }
            }
		})
    }

    update() {
        if(!this.attributes.coordinate) {
            if (this.attributes.type === 'number') {
                //console.log("form", this.form, this.attributes.name, this.form.get(this.attributes.name).value)

                const value = this.form.get(this.attributes.name).value

                var val
                if(!this.validations.allow_zero) {
                    if(typeof value === 'string') {
                        const valueTemp = value.includes(',') ? value.split(",").join("") : value
                        const parseValue = isNaN(parseFloat(valueTemp)) ? 0 : parseFloat(valueTemp)
                        val = this.pipe.transformFloat(parseValue, parseValue > 100)
                    } else {
                        val = this.pipe.transformFloat(value, value > 100)
                    }

                    val = this.validations.disabled && parseFloat(val) === 0 
                        ? 0 
                        : parseFloat(val) === 0 
                            ? '' 
                            : val
                } else {
                    if(typeof value === 'string') {
                        const valueTemp = value.includes(',') ? value.split(",").join("") : value

                        if(isNaN(parseFloat(valueTemp))) {
                            val = ''
                        } else {
                            const parseValue = parseFloat(valueTemp)
                            val = this.pipe.transformFloat(parseValue, parseValue > 100)
                        }
                    } else {
                        val = this.pipe.transformFloat(value, value > 100)
                    }
                }

                this.form.get(this.attributes.name).patchValue(val)


                /* let val
                console.log("form", this.form, this.attributes.name)
                if (!isNaN(this.form.get(this.attributes.name).value)) {
                    const value = "" + this.form.get(this.attributes.name).value
                    const valueTemp = value.includes(',') ? value.split(",").join("") : value
                    const parseValue = parseFloat(valueTemp)

                    console.log("valores", val, value, valueTemp, parseValue)

                    val = this.pipe.transform("" + parseValue, parseValue > 100)
                } else {
                    val = ""
                }
                this.form.get(this.attributes.name).patchValue(val) */
            } else if(this.attributes.type === 'number_integer') {
                const value = this.form.get(this.attributes.name).value

                var val
                if(typeof value === 'string') {
                    const valueTemp = value.includes(',') ? value.split(",").join("") : value
                    const parseValue = parseInt(valueTemp)
                    val = this.pipe.transformInt(parseValue, parseValue > 100)
                } else {
                    val = this.pipe.transformInt(value, value > 100)
                }

                val = parseInt(val) === 0 ? '' : val

                this.form.get(this.attributes.name).patchValue(val)
            }
        }

        // Auto calculate "Calculo total de cobre aplicado" to form FINS-08
        if(this.areFormControlsReady(
            'calculo_cobre_productos_porcentaje_cobre',
            'calculo_cobre_productos_aplicacion',
            'calculo_cobre_productos_superficie'
        )) {
            const porcentaje = this.stringToNumber(this.form.get('calculo_cobre_productos_porcentaje_cobre').value)
            const aplicacion = this.stringToNumber(this.form.get('calculo_cobre_productos_aplicacion').value)
            const superficie = this.stringToNumber(this.form.get('calculo_cobre_productos_superficie').value)

            if(
                typeof porcentaje === 'number' && typeof aplicacion === 'number' && typeof superficie === 'number' &&
                porcentaje !== 0 && aplicacion !== 0 && superficie !== 0
            ) {
                const total_cobre = ((porcentaje / 100) * aplicacion) / superficie
                const value = this.pipe.transformFloat(total_cobre, total_cobre > 100)
                this.form.get('calculo_total_cobre_aplicado')?.patchValue(value)
            }
        }

        // Auto calculate "Calculo total de nitrogeno aplicado soluble" to form FINS-09
        if(this.areFormControlsReady(
            'calculo_nitrogeno_porcentaje_nitrogeno',
            'calculo_nitrogeno_cantidad_aplicada',
            'calculo_nitrogeno_superficie'
        )) {
            const porcentaje = this.stringToNumber(this.form.get('calculo_nitrogeno_porcentaje_nitrogeno').value)
            const aplicacion = this.stringToNumber(this.form.get('calculo_nitrogeno_cantidad_aplicada').value)
            const superficie = this.stringToNumber(this.form.get('calculo_nitrogeno_superficie').value)

            if(
                typeof porcentaje === 'number' && typeof aplicacion === 'number' && typeof superficie === 'number' &&
                porcentaje !== 0 && aplicacion !== 0 && superficie !== 0
            ) {
                const total_nitrogeno = ((porcentaje / 100) * aplicacion) / superficie
                const value = this.pipe.transformFloat(total_nitrogeno, total_nitrogeno > 100)
                this.form.get('calculo_total_nitrogeno_aplicado')?.patchValue(value)
            }
        }

        // Auto calculate "Calculo total de fosforo aplicado soluble" to form FINS-09
        if(this.areFormControlsReady(
            'calculo_fosforo_porcentaje_fosforo',
            'calculo_fosforo_cantidad_aplicada',
            'calculo_fosforo_superficie'
        )) {
            const porcentaje = this.stringToNumber(this.form.get('calculo_fosforo_porcentaje_fosforo').value)
            const aplicacion = this.stringToNumber(this.form.get('calculo_fosforo_cantidad_aplicada').value)
            const superficie = this.stringToNumber(this.form.get('calculo_fosforo_superficie').value)

            if(
                typeof porcentaje === 'number' && typeof aplicacion === 'number' && typeof superficie === 'number' &&
                porcentaje !== 0 && aplicacion !== 0 && superficie !== 0
            ) {
                const total_fosforo = ((porcentaje / 100) * aplicacion) / superficie
                const value = this.pipe.transformFloat(total_fosforo, total_fosforo > 100)
                this.form.get('calculo_total_fosforo_aplicado')?.patchValue(value)
            }
        }

        
        // Auto calculate values to form FINS-03-12 in section "PROCESADORES / COMERCIALIZADORES"
        if(this.areFormControlsReady(
            'procesadores_comercializadores_4_resultado',
            'procesadores_comercializadores_5_resultado',
            'procesadores_comercializadores_6_resultado',
            'procesadores_comercializadores_7_resultado',
            'procesadores_comercializadores_8_resultado',
            'procesadores_comercializadores_9_resultado',
            'procesadores_comercializadores_10_resultado',
            'procesadores_comercializadores_11_resultado'
        )) {
            const inventarioInicial = this.stringToNumber(this.form.get('procesadores_comercializadores_4_resultado').value)
            const inventarioFinal = this.stringToNumber(this.form.get('procesadores_comercializadores_5_resultado').value)
            const produccionCompras = this.stringToNumber(this.form.get('procesadores_comercializadores_6_resultado').value)
            const ventas = this.stringToNumber(this.form.get('procesadores_comercializadores_7_resultado').value)
            const mermas = this.stringToNumber(this.form.get('procesadores_comercializadores_8_resultado').value)

            let inventarioFinalTeorico = 0
            let diferenciaInventarioFinalYTeorico = 0
            let volumenTotalComercializado = 0

            // Auto calculate "Inventario final teórico"
            if(typeof inventarioInicial === 'number' && typeof produccionCompras === 'number' && typeof ventas === 'number' && typeof mermas === 'number') {
                inventarioFinalTeorico = inventarioInicial + produccionCompras - ventas - mermas
            }

            // Auto calculate "Diferencia entre inventario final teórico y físico"
            if(typeof inventarioFinal === 'number' && typeof inventarioFinalTeorico === 'number') {
                diferenciaInventarioFinalYTeorico = inventarioFinalTeorico - inventarioFinal
            }

            // Auto calculate "Diferencia de inventario final en proporción con volumen total comercializado"
            if(
                typeof ventas === 'number' && typeof diferenciaInventarioFinalYTeorico === 'number' &&
                ventas !== 0 && diferenciaInventarioFinalYTeorico !== 0
            ) {
                volumenTotalComercializado = (diferenciaInventarioFinalYTeorico * 100) / ventas
            }
            
            // Set value "Inventario final teórico"
            const valueInventario = this.pipe.transformInt(inventarioFinalTeorico, inventarioFinalTeorico > 100)
            this.form.get('procesadores_comercializadores_9_resultado')?.patchValue(valueInventario)

            // Set value "Diferencia entre inventario final teórico y físico"
            const valueDiferencia = this.pipe.transformInt(diferenciaInventarioFinalYTeorico, diferenciaInventarioFinalYTeorico > 100)
            this.form.get('procesadores_comercializadores_10_resultado')?.patchValue(valueDiferencia)

            // Set value "Diferencia de inventario final en proporción con volumen total comercializado"
            const valueVolumenTotal = `${this.pipe.transformFloat(volumenTotalComercializado, volumenTotalComercializado > 100)} %`
            this.form.get('procesadores_comercializadores_11_resultado')?.patchValue(valueVolumenTotal)
        }

        // Auto calculate values to form FINS-03-12 in section "PROCESADORES MULTI-INGREDIENTES"
        if(this.areFormControlsReady(
            'procesadores_multi_ingredientes_4_resultado',
            'procesadores_multi_ingredientes_5_resultado',
            'procesadores_multi_ingredientes_6_resultado',
            'procesadores_multi_ingredientes_7_resultado',
            'procesadores_multi_ingredientes_8_resultado',
            'procesadores_multi_ingredientes_9_resultado',
            'procesadores_multi_ingredientes_10_resultado',
            'procesadores_multi_ingredientes_11_resultado'
        )) {
            const inventarioInicial = this.stringToNumber(this.form.get('procesadores_multi_ingredientes_4_resultado').value)
            const inventarioFinal = this.stringToNumber(this.form.get('procesadores_multi_ingredientes_5_resultado').value)
            const produccionCompras = this.stringToNumber(this.form.get('procesadores_multi_ingredientes_6_resultado').value)
            const ventas = this.stringToNumber(this.form.get('procesadores_multi_ingredientes_7_resultado').value)
            const mermas = this.stringToNumber(this.form.get('procesadores_multi_ingredientes_8_resultado').value)

            let inventarioFinalTeorico = 0
            let diferenciaInventarioFinalYTeorico = 0
            let volumenTotalComercializado = 0

            // Auto calculate "Inventario final teórico"
            if(typeof inventarioInicial === 'number' && typeof produccionCompras === 'number' && typeof ventas === 'number' && typeof mermas === 'number') {
                inventarioFinalTeorico = inventarioInicial + produccionCompras - ventas - mermas
            }

            // Auto calculate "Diferencia entre inventario final teórico y físico"
            if(typeof inventarioFinal === 'number' && typeof inventarioFinalTeorico === 'number') {
                diferenciaInventarioFinalYTeorico = inventarioFinalTeorico - inventarioFinal
            }

            // Auto calculate "Diferencia de inventario final en proporción con volumen total comercializado"
            if(
                typeof ventas === 'number' && typeof diferenciaInventarioFinalYTeorico === 'number' &&
                ventas !== 0 && diferenciaInventarioFinalYTeorico !== 0
            ) {
                volumenTotalComercializado = (diferenciaInventarioFinalYTeorico * 100) / ventas
            }
            
            // Set value "Inventario final teórico"
            const valueInventario = this.pipe.transformInt(inventarioFinalTeorico, inventarioFinalTeorico > 100)
            this.form.get('procesadores_multi_ingredientes_9_resultado')?.patchValue(valueInventario)

            // Set value "Diferencia entre inventario final teórico y físico"
            const valueDiferencia = this.pipe.transformInt(diferenciaInventarioFinalYTeorico, diferenciaInventarioFinalYTeorico > 100)
            this.form.get('procesadores_multi_ingredientes_10_resultado')?.patchValue(valueDiferencia)

            // Set value "Diferencia de inventario final en proporción con volumen total comercializado"
            const valueVolumenTotal = `${this.pipe.transformFloat(volumenTotalComercializado, volumenTotalComercializado > 100)} %`
            this.form.get('procesadores_multi_ingredientes_11_resultado')?.patchValue(valueVolumenTotal)
        }

        if(this.attributes.name === 'no_conformidad_fecha_limite') {
            this.form.get(this.attributes.name).setValue('30 días hábiles después de la NC')
        }
        
        // Set Kg to FDOC-05
        if(this.areFormControlsReady(
            'kilogramos_cosechados'
        )) {
            // Get number of box and weight
            const cajas = this.stringToNumber(this.form.get('numero_cajas').value)
            const peso = this.stringToNumber(this.form.get('peso_cajas').value)

            // Calculate Kg. using number of box and weight
            const kilogramos = cajas * peso

            // Set Kg.
            this.form.get('kilogramos_cosechados').patchValue(kilogramos)
        }

        // Certificate
        if(this.attributes.name === 'unit_name') {
            const newUnit = this.form.get(this.attributes.name).value

            if(newUnit !== null && newUnit.replace(/\s/g, "").length > 0) {
                const evaluationId = this.route.snapshot.params['id'];
                const units_storage = localStorage.getItem("unitsCertified"+evaluationId) || '[]'
                let units: string[] = JSON.parse(units_storage)

                if(!units.includes(newUnit)) {
                    units.push(newUnit)

                    localStorage.setItem("unitsCertified"+evaluationId, JSON.stringify(units))

                    setTimeout(() => {
                        this.communicationService.emitEvent({
                            identifier: 'update-units_certificate',
                        })
                    }, 100);
                }
            }
        }
    }

    stringToNumber(value) {
        if(typeof value === 'number') {
            return value
        }

        const valueTemp = value.includes(',') ? value.split(",").join("") : value
        return isNaN(parseFloat(valueTemp)) ? 0 : parseFloat(valueTemp)
    }

    private areFormControlsReady(...names: string[]): boolean {
        return names.every(name => this.form.get(name));
    }

    ngOnInit(): void {
        // asign parent formGroup to local formGroup
        if (!this.form) {this.form = this.parentControl.formGroup}
        // iterate and access component attributes
        for (var i in this.data.attributes) {
            const attribute = this.data.attributes[i]
            this.attributes[attribute.name] = attribute.value
        }
        for (var i in this.data.validations) {
            const validation = this.data.validations[i]
            this.validations[validation.name] = validation.value
        }
        if (this.attributes.conditional_name) {
            for (var i in this.attributes.conditional_name) {
                const name = this.attributes.conditional_name[i]
                this.form.addControl(name, new FormControl(this.attributes.default ? this.attributes.default : ''))
            }
        } else {
            this.form.addControl(this.attributes.name, new FormControl(this.attributes.default ? this.attributes.default : ''))
        }

        this.update()
    }

    onInput(event: any) {
        const cleaned = event.target.value.replace(/[\u0000-\u0008\u000B\u000C\u000E-\u001F\u007F]/g, ' ')
        if (event.target.value !== cleaned) {
            event.target.value = cleaned
        }
    }

}
